import React, { useEffect, useState } from 'react'
import useVideoConfigS3 from '../HelperComponent/useVideoConfigS3';

const useAuditionVideoUpload = () => {
  const [s3,bucketName] = useVideoConfigS3([]);
  const [videoProgress, setProgress] = useState(0);
  const [videoUrls, setFileUrls] = useState([]);
  const [videoKeys, setFileKeys] = useState([]);

  const [uploadFiles, setFiles] = useState(null);
  const [deleleFileKey, setDeleteFile] = useState(null);

  console.log('uploadFiles',uploadFiles);

  useEffect(() => {
    setDeleteFile();
    setProgress(0);
    setFileUrls([]);
    setFileKeys([]);
  }, []);

  useEffect(() => {
    if (deleleFileKey) {
      handleDelete(deleleFileKey);
      setDeleteFile(null);
    }
  }, [deleleFileKey]);

  const handleDelete = (delFile) => {
    const params = {
      Bucket: bucketName,
      Key: delFile,
    };

    s3.deleteObject(params, (err, data) => {

      if (err) {
        console.error(err);
        //return;
      }
      setFileKeys((prevState) =>
      prevState.filter((key) => key !== delFile)
    );
      console.log(data);
    });
  };

  const handleUpload = (video) => {
    const extension = video.name.split(".").pop();
    const videoName = new Date().getTime() + "." + extension;

    const params = {
      Bucket: process.env.REACT_APP_S3_BUCKET_VIDEOS,
      Key: 'audition/videos' + "/" + videoName,
      Body: video,
    };

    s3.upload(params, (err, data) => {
      if (err) {
        console.error(err);
        if (err.code === "NetworkingError" || err.code === "TimeoutError") {
            // retry upload
            handleUpload();
          } 
        return;
      }
      setFileUrls((prevState) => [...prevState, data.Location]);
      setFileKeys((prevState) => [...prevState, data.Key]);
    }).on("httpUploadProgress", (evt) => {
      const progressPercentage = parseInt((evt.loaded * 100) / evt.total);
      setProgress(progressPercentage);
    });
  };
  if(uploadFiles){
      handleUpload(uploadFiles)
      setFiles(null)
  }




  return [videoUrls, videoKeys, videoProgress, setFiles, setDeleteFile,setProgress];
};

export default useAuditionVideoUpload;
